import DefaultBlockquote, { inputRegex } from '@tiptap/extension-blockquote';
import { wrappingInputRule } from '@tiptap/core';

import { createBlockquoteSelfQuotedDecorationPlugin } from '../utils/blockquoteSelfQuotedDecorationPlugin';

export const Blockquote = DefaultBlockquote.extend({
    content: 'paragraph+',

    addCommands() {
        return {
            ...this.parent?.(),
            /**
             * We want to ensure that any list nodes are removed before setting the blockquote.
             */
            toggleBlockquote:
                () =>
                ({ chain }) =>
                    chain()
                        // First remove any nodes from lists and clear their current block types
                        .clearBlockNodes()
                        .toggleWrap(this.name)
                        .run(),
        };
    },

    addKeyboardShortcuts() {
        return {
            // Keeping the original Tiptap shortcut, in case it's standard
            'Mod-Shift-b': () => this.editor.commands.toggleBlockquote(),
            "Mod-'": () => this.editor.commands.toggleBlockquote(),
            'Mod-"': () => this.editor.commands.toggleBlockquote(),
        };
    },

    /**
     * Overrides the default behaviour to ensure that new blockquotes created underneath
     * each other aren't merged.
     */
    addInputRules() {
        return [
            wrappingInputRule({
                find: inputRegex,
                type: this.type,
                // Never join to a previous blockquote
                joinPredicate: () => false,
            }),
        ];
    },

    /**
     * Hides the decorative CSS quotes for blockquotes whose text is already wrapped in
     * quotes. This is rendering-only: it adds a class via a decoration and never modifies
     * the underlying content.
     */
    addProseMirrorPlugins() {
        return [createBlockquoteSelfQuotedDecorationPlugin(), ...(this.parent?.() ?? [])];
    },
});
